import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import FhirLoader from '../../../../FhirLoader'
import { MedicationRequest } from '@teschglobal/tg-fhir-react-components'
import type { MedicationRequest as FHIRMedicationRequest } from '@teschglobal/tg-fhir-react-components/dist/types'
import useFhirConfig from '../../../../../hooks/admin/useFhirConfig'
import { MedicationRequestBundle } from '../../../../../types/FHIRTypes/Bundle'
import { UseQueryResult } from 'react-query'
import useFhirResourceById from '../../../../../hooks/admin/useFhirResourceById'

type MedicationDetailProps = {
    medicationDetailId: string | undefined
}
const MedicationDetail: React.FC<MedicationDetailProps> = ({ medicationDetailId}) => {

    const { patientAccessFhirConfig } = useFhirConfig()

      const {
        data: medicationRequest,
        isFetching,
        isLoading,
        isError
      }: UseQueryResult<FHIRMedicationRequest, Error> =
        useFhirResourceById('Patient Access', medicationDetailId || '', 'MedicationRequest')
    
      if (isFetching || isLoading) {
        return <FhirLoader />
      }
    
      if (!medicationRequest || isError) {
        return <div className='text-center' role='status' aria-live='polite' aria-atomic='true'>Not Found</div>
      }
    
  
    return (
        <section>
            <MedicationRequest
                data={medicationRequest}
                fhirApiConfig={patientAccessFhirConfig} />
        </section>
    )
}

export default MedicationDetail
